import Axios from 'axios';
import qs from "qs";

const axiosInstance = Axios.create({
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosInstance.interceptors.request.use(req => {
    const token = localStorage.getItem('authToken');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    // 로그 남기기
    // console.log(`${JSON.stringify(req, null, 10000000)}`);
    return req;
});

axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    (error) => {
        // const navigator = useNavigate();
        console.log(error);
        const status = error?.response?.status;

        if (status === 400) {
            alert(error?.response?.data?.message + '' || 'Bad Request');
        }

        if (status === 403) {
            window.location.href = "/login.html";
        }

        if (status === 409) {
            alert(error?.response?.data?.message + '' || 'Domain Exception');
        }

        if (status === 500) {
            alert(error?.response?.data?.detail || '알 수 없는 에러 발생.');
        }

        return Promise.reject(error);
    }
);

axiosInstance.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' })
}

export const formUrlEncodedHeaders = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
};

export const axiosForm = Axios.create({
    timeout: 5000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
});

export default axiosInstance;